import React from "react";
import { Box, Typography } from "@mui/material";
import { ds } from "../../styles/designSystem";

export function FieldLabel({ children, required = false, sx }) {
    return (
        <Typography sx={{ ...ds.components.form.label, ...sx }}>
            {children}
            {required && <Box component="span" sx={ds.components.form.requiredMark}> *</Box>}
        </Typography>
    );
}

export default function FormField({ label, required = false, children, sx, labelSx }) {
    return (
        <Box sx={{ ...ds.components.form.field, ...sx }}>
            <FieldLabel required={required} sx={labelSx}>{label}</FieldLabel>
            {children}
        </Box>
    );
}
